import React from "react";
import { useTranslation } from 'next-i18next';
import { Gradient2, About } from "assets/vectors";
import { TextHeadingOne, ParagraphText } from "styles/typography";
import { BannerWrapepr } from "./about-banner.styles";

const AboutBanner = () => {
   const { t } = useTranslation('common');
   return (
      <BannerWrapepr>
         <Gradient2 style={{ position: "absolute", top: "-200px", left: "-200px" }} />
         <div style={{ position: "relative" }}>
            <About style={{ position: "absolute", left: "-100px" }} />
            <br />
            <TextHeadingOne style={{ zIndex: 1000 }}>{t('seo-about-title')}</TextHeadingOne>
         </div>

         <div style={{ alignSelf: "end", justifySelf: "flex-end" }}>
            <ParagraphText>
               {t('seo-about-description')}
            </ParagraphText>
         </div>
      </BannerWrapepr>
   );
};

export default AboutBanner;
